import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wechat-slider-gate",
  "aria-label": "访问验证"
}
const _hoisted_2 = {
  class: "slider-card",
  "aria-labelledby": "slider-gate-title"
}
const _hoisted_3 = { class: "slider-text" }

import {computed, onMounted, ref} from 'vue';
import {showMsg} from '@/utils/msg';

interface Props {
  enabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WechatSliderGate',
  props: {
    enabled: { type: Boolean, default: true }
  },
  emits: ["verified"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isWechat = ref(false);
const sliderValue = ref(0);
const isDragging = ref(false);
const isVerified = ref(false);

const sliderText = computed(() =>
    isVerified.value ? '验证成功' : '向右拖动滑块验证',
);

function finishDrag(): void {
  isDragging.value = false;

  if (sliderValue.value < 96 || isVerified.value) {
    sliderValue.value = 0;
    return;
  }

  sliderValue.value = 100;
  isVerified.value = true;
  emit('verified');
}

function startDrag(): void {
  isDragging.value = true;
}

async function copyCurrentLink(): Promise<void> {
  const link = window.location.href;
  let copied = false;

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(link);
      copied = true;
    }
  } catch {
    copied = false;
  }

  if (!copied) {
    const textarea = document.createElement('textarea');
    textarea.value = link;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    textarea.style.pointerEvents = 'none';
    document.body.appendChild(textarea);
    textarea.select();
    copied = document.execCommand('copy');
    document.body.removeChild(textarea);
  }

  showMsg(copied ? '链接复制成功，可用浏览器进行访问。' : '复制失败，请手动复制链接');
}

onMounted(() => {
  if (!props.enabled) {
    emit('verified');
    return;
  }

  // isWechat.value = true;

  try {
    isWechat.value = /MicroMessenger/i.test(navigator.userAgent || '');
  } catch {
    isWechat.value = false;
  }

  // 非微信环境不显示开关，直接挂载原有页面。
  if (!isWechat.value) {
    emit('verified');
  }
});

return (_ctx: any,_cache: any) => {
  return (__props.enabled && isWechat.value && !isVerified.value)
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("h1", { id: "slider-gate-title" }, "请完成验证", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", null, "请将滑块拖动至最右侧后继续访问", -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["slider-track", { 'is-dragging': isDragging.value }])
          }, [
            _createElementVNode("div", {
              class: "slider-progress",
              style: _normalizeStyle({ width: `${sliderValue.value}%` })
            }, null, 4),
            _createElementVNode("span", _hoisted_3, _toDisplayString(sliderText.value), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sliderValue).value = $event)),
              class: "slider-input",
              type: "range",
              min: "0",
              max: "100",
              step: "1",
              "aria-label": "向右拖动完成验证",
              onPointerdown: startDrag,
              onPointerup: finishDrag,
              onPointercancel: finishDrag,
              onTouchend: finishDrag,
              onInput: _cache[1] || (_cache[1] = ($event: any) => (isDragging.value = true)),
              onChange: finishDrag
            }, null, 544), [
              [
                _vModelText,
                sliderValue.value,
                void 0,
                { number: true }
              ]
            ]),
            _createElementVNode("span", {
              class: "slider-handle",
              style: _normalizeStyle({ left: `calc(${sliderValue.value}% - ${sliderValue.value * 0.44}px)` }),
              "aria-hidden": "true"
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("span", null, "›", -1)
            ]))], 4)
          ], 2),
          _createElementVNode("button", {
            class: "copy-link-button",
            type: "button",
            onClick: copyCurrentLink
          }, " 复制链接 ")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})